import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from 'react-router-dom';
import { getIdData, addData, updateData } from '../../../lib/studentchecklist';
import {ChekListTypeSelect} from "../../ui/myselect";

const URGENCY = {
  'Must': 'Must',
  'Should': 'Should',
  'BetterHave': 'Better Have',
};

// const months = [
//   'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'
// ];
const months = [
  'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
];

export default function GlobalCheckListEdit() {
  const [startMonth, setStartMonth] = useState("");
  const [endMonth, setEndMonth] = useState("");
  const [urgency, setUrgency] = useState("Must");
  const [taskId, setTaskId] = useState('');
  const [tDate, setTDate] = useState('');
  const [isDone, setIsDone] = useState(false);
  const [isProgress, setIsProgress] = useState(false);
  const [data, setData] = useState([])
  const navigate = useNavigate();
  const { slug, status, id } = useParams();

  console.log('Slug: ', slug, 'Status: ',status, 'Id: ', id)
  async function GetData() {

    //data
    const checkListData = await getIdData(id);
    console.log("parameterData", checkListData[0]);
    setData(checkListData);
    setStartMonth(checkListData[0].startMonth);
    setEndMonth(checkListData[0].endMonth);
    setUrgency(checkListData[0].urgency);
    setTaskId(checkListData[0].taskId);
    setTDate(checkListData[0].tDate);
    setIsDone(checkListData[0].isDone);
    setIsProgress(checkListData[0].isProgress);



//isDisabled = {slug === "Add" ? false : true}
  }
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (status === "Add") {
      console.log("Add" , taskId);

    const newTask = {
      studentId: slug,
      startMonth: startMonth,
      endMonth: endMonth,
      urgency: urgency,
      taskId: taskId,
      tDate: tDate,
      isDone: isDone,
      isProgress: isProgress,
    };
		console.log('new task: ', newTask)
    try {
      await addData(newTask);
      // navigate('/student/student-goal-questions');
      navigate(-1);
			// console.alert ('It will nevigate...')
    } catch (error) {
      console.error("There was an error adding the task!", error);
    }
  }
  else{
    const updatedTask = {
      id:id,
      studentId: slug,
      startMonth: startMonth,
      endMonth: endMonth,
      urgency: urgency,
      taskId: taskId,
      tDate: tDate,
      isDone: isDone,
      isProgress: isProgress,
    };
    console.log('Updated task: ', updatedTask)
    try {
      await updateData(updatedTask);
      // navigate('/student/student-goal-questions');
      navigate(-1);
			// console.alert ('It will nevigate...')
    } catch (error) {
      console.error("There was an error adding the task!", error);
    }
  console.log('first')
  }
};
useEffect(() => {
  if (status === "Update") {
    GetData();
  }

}, [status])


  return (
    <div className="container mt-5">
       <h3>{status === "Add" ? "Add Task" : "Update Task"}</h3>
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label>Time Frame</label>
          <div className="d-flex align-items-center">
            <select
              className="form-control mr-1"
              value={startMonth}
              onChange={(e) => setStartMonth(e.target.value)}
              required
            >
              <option value="">Start Month</option>
              {months.map((month, index) => (
                <option key={index} value={month}>{month}</option>
              ))}
            </select>
            -
            <select
              className="form-control ml-1"
              value={endMonth}
              onChange={(e) => setEndMonth(e.target.value)}
              required
            >
              <option value="">End Month</option>
              {months.map((month, index) => (
                <option key={index} value={month}>{month}</option>
              ))}
            </select>
          </div>
        </div>
        <div className="form-group">
          <label>Urgency</label>
          <select
            className="form-control"
            value={urgency}
            onChange={(e) => setUrgency(e.target.value)}
            required
          >
            {Object.keys(URGENCY).map(key => (
              <option key={key} value={key}>{URGENCY[key]}</option>
            ))}
          </select>
        </div>
        <div className="form-group">
          <label className="form-control-label" >Task</label>
           <ChekListTypeSelect value={taskId} setValue={setTaskId}/>
                        
        </div>
        <div className="form-group">
          <label>Date</label>
          <input
            type="date"
            className="form-control"
            value={tDate}
            onChange={(e) => setTDate(e.target.value)}
            required
          />
        </div>
        <div className="form-group form-check">
          <input
            type="checkbox"
            className="form-check-input"
            checked={isDone}
            onChange={(e) => setIsDone(e.target.checked)}
          />
          <label className="form-check-label">Done</label>
        </div>
        <div className="form-group form-check">
          <input
            type="checkbox"
            className="form-check-input"
            checked={isProgress}
            onChange={(e) => setIsProgress(e.target.checked)}
          />
          <label className="form-check-label">In Progress</label>
        </div>
				<div className="update-profile d-flex justify-content-between" >
        <button type="submit" className="btn btn-primary">
                            {status === "Add" ? "Add Task" : "Update Task"}
                          </button>
        <button type="button" className="btn btn-black btn-sm" onClick={() => navigate(-1)}>Cancel</button>
				</div>
      </form>
    </div>
  );
}
